import React from 'react';
import { Image } from '@mantine/core';
import styles from './HeroImg.module.scss';

import placeholder from '@/assets/images/example4.jpg';

interface Props {
	src: string;
}

export const HeroImg: React.FC<Props> = ({ src }) => {
	return (
		<Image
			maw={600}
			src={placeholder}
			width="auto"
			alt="Landing Page"
			classNames={{ root: styles.root }}
		/>
	);
};
